import _has from 'lodash/has';
import _get from 'lodash/get';


export interface GradientPresetItem {
    type: string;
    style: string;
    angle: number;
    list: { pos: number; color: string }[];
}

/**
 * 渐变预设值
 */
export const GradualList: GradientPresetItem[] = [
    {
        type: 'linear', style: 'gra-preset-22', angle: 225, list: [{ pos: 0, color: '#E5EFFF' }, { pos: 100, color: '#99BEFF' }],
    },
    {
        type: 'linear', style: 'gra-preset-23', angle: 225, list: [{ pos: 0, color: '#FFF9E3' }, { pos: 100, color: '#C7ECFF' }],
    },
    {
        type: 'linear', style: 'gra-preset-1', angle: 225, list: [{ pos: 0, color: '#FFC8B8' }, { pos: 100, color: '#E06666' }],
    },
    {
        type: 'linear', style: 'gra-preset-3', angle: 225, list: [{ pos: 0, color: '#FFF2CC' }, { pos: 100, color: '#FFB700' }],
    },
    {
        type: 'linear', style: 'gra-preset-4', angle: 225, list: [{ pos: 0, color: '#D9EAD3' }, { pos: 100, color: '#678F00' }],
    },
    {
        type: 'linear', style: 'gra-preset-5', angle: 225, list: [{ pos: 0, color: '#DFF8FF' }, { pos: 100, color: '#0397E2' }],
    },
    {
        type: 'linear', style: 'gra-preset-6', angle: 225, list: [{ pos: 0, color: '#CFC7F4' }, { pos: 100, color: '#2741B1' }],
    },
    {
        type: 'linear', style: 'gra-preset-7', angle: 225, list: [{ pos: 0, color: '#FEE4FF' }, { pos: 100, color: '#A419D3' }],
    },
    {
        type: 'linear', style: 'gra-preset-8', angle: 225, list: [{ pos: 0, color: '#FFC8B8' }, { pos: 100, color: '#E75200' }],
    },
    {
        type: 'linear', style: 'gra-preset-9', angle: 225, list: [{ pos: 0, color: '#ACDB7E' }, { pos: 100, color: '#DFF8FF' }],
    },
    {
        type: 'linear', style: 'gra-preset-10', angle: 225, list: [{ pos: 0, color: '#8C7BE8' }, { pos: 100, color: '#FEE4FF' }],
    },
    {
        type: 'linear', style: 'gra-preset-11', angle: 225, list: [{ pos: 0, color: '#EE93F6' }, { pos: 100, color: '#FFD966' }],
    },
    {
        type: 'linear', style: 'gra-preset-12', angle: 225, list: [{ pos: 0, color: '#D041E1' }, { pos: 100, color: '#E75200' }],
    },
    {
        type: 'linear', style: 'gra-preset-13', angle: 225, list: [{ pos: 0, color: '#A419D3' }, { pos: 100, color: '#2741B1' }],
    },
    {
        type: 'linear', style: 'gra-preset-14', angle: 225, list: [{ pos: 0, color: '#FFB700' }, { pos: 100, color: '#E75200' }],
    },
    {
        type: 'linear', style: 'gra-preset-15', angle: 225, list: [{ pos: 0, color: '#E9E9E9' }, { pos: 100, color: '#D9D9D9' }],
    },
    {
        type: 'linear', style: 'gra-preset-16', angle: 225, list: [{ pos: 0, color: '#C4C4C4' }, { pos: 100, color: '#9D9D9D' }],
    },
    {
        type: 'linear', style: 'gra-preset-19', angle: 225, list: [{ pos: 0, color: '#D9D9D9' }, { pos: 100, color: '#555555' }],
    },
    {
        type: 'linear', style: 'gra-preset-20', angle: 225, list: [{ pos: 0, color: '#9D9D9D' }, { pos: 100, color: '#262626' }],
    },
    {
        type: 'linear', style: 'gra-preset-21', angle: 225, list: [{ pos: 0, color: '#434343' }, { pos: 100, color: '#000000' }],
    },
];

export default class GradualPreset {
    public static getPresetItemByStyle(presetStyle: string): GradientPresetItem | undefined {
        const gradualList = GradualList.concat();
        for (let b = 0; b < gradualList.length; b++) {
            const item = gradualList[b];
            if (presetStyle === item.style) {
                return item;
            }
        }
    }

    /* eslint-disable complexity */
    public static compareWithPreset(gradFill: any, angle?: number): GradientPresetItem | null {
        if (!gradFill) return null;
        const type = _get(gradFill, 'pathGradient.path');
        angle = angle || _get(gradFill, 'lin.ang');
        let point0 = '';
        let point100 = '';
        if (_has(gradFill, 'gsList')) {  // 锚点集合
            if (gradFill.gsList.length === 2) {
                const item0 = gradFill.gsList[0];
                point0 = `${item0.pos}-${item0.color ? item0.color.srgb_color : ''}`;

                const item100 = gradFill.gsList[1];
                point100 = `${item100.pos}-${item100.color ? item100.color.srgb_color : ''}`;
            }
        }

        const gradualList = GradualList.concat();
        for (let b = 0; b < gradualList.length; b++) {
            const item = gradualList[b];
            const p0 = `${item.list[0].pos}-${item.list[0].color}`;
            const p100 = `${item.list[1].pos}-${item.list[1].color}`;
            if (item.type === type && item.angle - 90 === angle) {
                // 2.0直接把色值从sdk上赋到了ui上，不带ff，但是3.0用了TDColor中转，默认会给结尾加上ff
                if (([p0, `${p0}ff`].includes(point0)) && ([p100, `${p100}ff`].includes(point100))) {
                    return item;
                }
            }
        }
        return null;
    }
}
